import { deleteApi, postApi } from '../../../../../utils/api'

export function addLike(data) {
  return postApi({ data, endpoint: '/api/like/' })
}

export function deleteLike(data) {
  return deleteApi({ data, endpoint: 'api/like/' })
}
